if (!customElements.get('fuji-localization')) {
  customElements.define('fuji-localization', class extends HTMLElement {
    connectedCallback() {
      this.lifecycle?.abort();
      this.lifecycle = new AbortController();
      const options = { signal: this.lifecycle.signal };
      this.disclosure = this.querySelector('details');
      if (!this.disclosure) return;
      this.addEventListener('submit', (event) => {
        const field = event.target.querySelector('input[name="return_to"]');
        const { pathname, search, hash } = window.location;
        if (field && pathname.startsWith('/') && !pathname.startsWith('//')) {
          let returnPath = pathname;
          const currentRoot = this.dataset.root;
          const targetRoot = event.target.dataset.localeRoot;
          const isRelativeRoot = root => typeof root === 'string' && root.startsWith('/') &&
            !root.startsWith('//') && !/[\\?#]/.test(root);
          if (isRelativeRoot(currentRoot) && isRelativeRoot(targetRoot)) {
            const currentPrefix = currentRoot.replace(/\/$/, '');
            const targetPrefix = targetRoot.replace(/\/$/, '');
            if (!currentPrefix || pathname === currentPrefix || pathname.startsWith(`${currentPrefix}/`)) {
              returnPath = targetPrefix + (pathname.slice(currentPrefix.length) || '/');
            }
          }
          field.value = `${returnPath}${search}${hash}`;
        }
      }, options);
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !this.disclosure.open) return;
        event.preventDefault();
        event.stopPropagation();
        this.disclosure.open = false;
        this.disclosure.querySelector('summary')?.focus();
      }, options);
      document.addEventListener('pointerdown', (event) => {
        if (!this.contains(event.target)) this.disclosure.open = false;
      }, options);
      this.addEventListener('focusout', (event) => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this.disclosure.open = false;
      }, options);
    }

    disconnectedCallback() {
      this.lifecycle?.abort();
    }
  });
}
